import { useMutation, useQueryClient } from "@tanstack/react-query";
import { UpdateMissionRoleInput } from "models/Rbac";
import queryKeys from "queries/keys";
import { updateMissionRole } from "services/rbac";
import { useRootStore } from "store";

export const useUpdateMissionRole = () => {
  const {
    authStore,
    accountsStore: { currentAccountId: accountId },
    uiStore: { setApiErrorToast },
  } = useRootStore();

  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (input: UpdateMissionRoleInput) => {
      const { missionSpecId, ...payload } = input;
      return updateMissionRole(authStore, missionSpecId, payload);
    },
    onSuccess: () => {
      queryClient.invalidateQueries(
        queryKeys.accounts.collaborators({ context: accountId }).queryKey
      );
    },
    onError: (error) => {
      setApiErrorToast(error, "Failed to update mission role");
    },
  });
};
